import { useMemo } from 'react';

const useFilterDisplay = ({ outputCurrencies, availableFilters, hideBudgetOnMultiCurrency }) => {
  const display = useMemo(() => {
    if (!availableFilters) {
      return [];
    }
    if (hideBudgetOnMultiCurrency && outputCurrencies && outputCurrencies.length !== 1) {
      return availableFilters.filter((f) => f !== 'Budget');
    }
    return availableFilters;
  }, [availableFilters, outputCurrencies, hideBudgetOnMultiCurrency]);

  return display;
};

export default useFilterDisplay;
